import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class RouterService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly location = inject(Location);

  public navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  public navigateToWithParams(url: string, params: Record<string, string>) {
    this.router.navigate([url], {
      queryParams: params,
    });
  }

  public goBack() {
    this.location.back();
  }

  public queryParams() {
    return this.activatedRoute.queryParams;
  }

  public snapshotQueryParams() {
    return this.activatedRoute.snapshot.queryParams;
  }

  public setQueryParams(params: Record<string, string>) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }
}
